module.exports = __webpack_public_path__ + "static/media/slide2.2ee3d609.jpg";